import { Ref } from 'vue';
import {
  ComponentContext,
  FormInstance,
  ComponentMetadata,
  ErrorHandlingMode,
} from '../schemas';
import { IAppHelpers } from './useHelpers';
import { SetDataOptions } from './useUserComponent';

export interface ComponentScopeExtras {
  emit: (event: string, ...args: any[]) => void;
  forms: Record<string, FormInstance | null>;
  error: Ref<any>;
  isModalComponent: Ref<boolean>;
  modalName: Ref<string | undefined>;
  componentMetadata: ComponentMetadata;
  loadData: (
    prop?: string | null,
    opts?: { initial?: boolean; errorHandling?: ErrorHandlingMode },
  ) => Promise<void>;
  registerForm: (name: string, form: FormInstance) => void;
  unregisterForm: (form: FormInstance) => void;
  setData: (path: string, value: any, opts?: SetDataOptions) => void;
  touchLastLoaded: () => void;
  handleError: (error: any) => void;
}

export function createComponentScope(
  helpers: IAppHelpers,
  extras: ComponentScopeExtras,
): ComponentContext {
  return {
    get $app() {
      return helpers.$app.value;
    },
    get $fn() {
      return helpers.$fn.value;
    },
    get $i18n() {
      return helpers.$i18n.value;
    },
    get $store() {
      return helpers.$store.value;
    },
    get $imodal() {
      return helpers.$imodal.value;
    },
    get $notification() {
      return helpers.$notification.value;
    },
    get $tabs() {
      return helpers.$tabs.value;
    },
    get $router() {
      return helpers.$router;
    },
    get forms() {
      return extras.forms;
    },
    get error() {
      return extras.error.value;
    },
    get isModalComponent() {
      return extras.isModalComponent.value;
    },
    get modalName() {
      return extras.modalName.value;
    },
    get componentMetadata() {
      return extras.componentMetadata;
    },
    $emit: extras.emit,
    loadData: extras.loadData,
    registerForm: extras.registerForm,
    unregisterForm: extras.unregisterForm,
    setData: extras.setData,
    touchLastLoaded: extras.touchLastLoaded,
    handleError: extras.handleError,
  } as ComponentContext;
}
